// auth.service.ts

import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StorageService } from './storage.service';
import { ToastrService } from 'ngx-toastr';
import { IdleService } from '../core/services/idle.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements CanActivate {

  constructor(
      private router: Router,
      private storageService: StorageService,
    private toastr: ToastrService,
    private idleService: IdleService,
    ) { }

  /**
   * Determines whether allow or not
   * @returns  
   */
  public canActivate(){

    // Authentication logic
    const isAuthenticated = this.checkIfUserIsAuthenticated();

    if (isAuthenticated) {
      return true;
    } else {
      // Navigate to the home page if not authenticated
      this.router.navigate(['/']);
      return false;
    }
  }

  /**
   * Checks if user is authenticated
   * @returns true if if user is authenticated
   */
  private checkIfUserIsAuthenticated(): boolean {
    if (this.hasValidSession()) {
      return true;
    } else if (this.storageService.getItem('token')) {
      // Signed in earlier but the session has expired: full logout (toast,
      // server logout, clear storage, disconnect wallet, back to login page).
      this.idleService.handleSessionExpired();
      return false;
    } else {
      this.toastr.error('You are not authenticated to access this page.', 'Authentication Error');
      return false;
    }
  }

  /**
   * True when localStorage holds a non-expired JWT.
   * wagmi_new_store only reflects wallet-connection state, not a verified
   * backend session, so it must not be used as an authentication signal.
   */
  private hasValidSession(): boolean {
    const token = this.storageService.getItem('token');
    if (!token) return false;

    const expiryRaw = this.storageService.getItem('expiryTime');
    const expiry = expiryRaw ? Number(JSON.parse(expiryRaw)) : 0;
    return Number.isFinite(expiry) && expiry > Date.now();
  }
  
}
